import { defineStore } from 'pinia'
import { toast } from 'vue-sonner'
import { settingsApi as api } from '@/api/endpoints/settings'
import { downloadExcelExport } from '@/lib/export.js'
import { invalidateList } from '@/queries/storeCache'

export const useSettingsStore = defineStore('settings', {
  state: () => ({
    generalSettings: null,
    loadingSettings: false,
  }),
  actions: {
    async GetGeneralSettings(_refresh = false) {
      // if (this.generalSettings && !refresh) return
      this.loadingSettings = true
      try {
        const body = await api.generalSettings()
        this.generalSettings = body.data.settings

        let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'icon'; // Use 'icon' or 'shortcut icon' for broad support
        if (this.generalSettings?.[0]?.favicon_url) {
          link.href = this.generalSettings[0].favicon_url;
          document.getElementsByTagName('head')[0].appendChild(link);
        }

        return body.data
      } finally {
        this.loadingSettings = false
      }
    },

    async UpdateGeneralSettings(payload) {
      const body = await api.updateGeneralSettings(payload)
      this.generalSettings = [body.data]
      toast.success(body.message)
      return body.data
    },

    async GetRole(id) {
      const body = await api.role(id)
      return body.data
    },

    async DeleteRole(id) {
      const body = await api.deleteRole(id)
      toast.success(body.message)
      invalidateList('roles')
      return body.data
    },

    async CreateRole(payload) {
      const body = await api.createRole(payload)
      toast.success(body.message)
      invalidateList('roles')
      return body.data
    },

    async UpdateRole(payload) {
      const body = await api.updateRole(payload)
      toast.success(body.message)
      invalidateList('roles')
      return body.data
    },

    async CreateBlog(payload) {
      const body = await api.createBlog(payload)
      toast.success(body.message)
      invalidateList('blogs')
      return body.data
    },

    async UpdateBlog(blog_id, payload) {
      const body = await api.updateBlog(blog_id, payload)
      toast.success(body.message)
      invalidateList('blogs')
      return body.data
    },

    async DeleteBlog(blog_id) {
      const body = await api.deleteBlog(blog_id)
      toast.success(body.message)
      invalidateList('blogs')
      return body.data
    },

    async GetModules() {
      const body = await api.modules()
      return body.data
    },

    async ToggleModuleStatus(payload, bulk = false) {
      const body = await api.toggleModuleStatus(payload, bulk)
      toast.success(body.message)
      // The catalog and every workspace dashboard (sidebar modules, isModuleEnabled) reflect this.
      invalidateList('modules')
      invalidateList('workspace-dashboard')
      return body.data
    },

    async GetUsersWithGlobalRoles(params = {}) {
      const body = await api.usersWithGlobalRoles(params)
      return body.data
    },

    async ExportUsersWithGlobalRoles(params = {}) {
      return downloadExcelExport('/users/export', {
        params,
        filename: 'role-visibility.xlsx',
      })
    },

    async UpdateUserRoleVisibility(userId, payload) {
      const body = await api.updateUserRoleVisibility(userId, payload)
      toast.success(body.message)
      invalidateList('global-role-users')
      return body.data
    },
  },
  persist: {
    pick: ['generalSettings']
  }
})
